__turbopack_context__.v({
  "productListItem": "styles-module__C2pURa__productListItem",
  "seeMoreText": "styles-module__C2pURa__seeMoreText",
});
